import { AnimatePresence, motion } from 'framer-motion';
import { IoChevronDown, IoChevronUpOutline } from 'react-icons/io5';
import { cn } from '../../cn';

interface AccordionProps extends Omit<React.ComponentProps<'div'>, 'title'> {
  title: React.ReactNode;
  children: React.ReactNode;
  open: boolean;
  onToggle: () => void;
}

export const Accordion = (props: AccordionProps) => {
  const { open, className, onToggle, title, children, ...rest } = props;

  return (
    <div {...rest}>
      <div className='flex flex-col'>
        <button type='button' onClick={onToggle} className={className}>
          <span className='flex-1 min-w-0 w-full'>{title}</span>
          {open ? (
            <IoChevronUpOutline className='text-default-800 md:w-5 md:h-5 w-4 h-4' />
          ) : (
            <IoChevronDown className='text-default-800 md:w-5 md:h-5 w-4 h-4' />
          )}
        </button>

        <AnimatePresence initial={false}>
          {open && (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: 'auto' }}
              exit={{ height: 0 }}
              transition={{ type: 'spring', duration: 0.6, bounce: 0 }}
              className={cn('overflow-hidden')}
            >
              {children}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
